//deps
import React, { useMemo } from "react";

//native-bridge
import { Sdk } from "@client/includes/NativeBridgeSdk";
import { NativeBridge } from "@swiggy-private/native-bridge";

//internal-deps
import { PaymentMain, PaymentMainProps } from "@swiggy-private/payment-client";
import { ExternalRoutes } from "../ExternalRoutes";
import { Container } from "../App/styled";
import { GlobalDisableCopyPaste } from "../styles/Global";

//helpers
import { getPaymentInitialState } from "@client/helpers/Payment";
type Dict<T> = { [header: string]: T | undefined };

interface PaymentProps {
    apiHost: string;
    paymentHost: string;
    analyticsHost: string;
    headers: Dict<string>;
    path: string;
    simplPostLinkingRedirectUrl: string;
}

function getPaymentProps(props: PaymentProps): PaymentMainProps {
    const { apiHost, analyticsHost, paymentHost, headers, path, simplPostLinkingRedirectUrl } = props;

    const initialState = getPaymentInitialState(path);

    return {
        nativeBridgeSdk: Sdk as NativeBridge,
        config: {
            apiHost,
            paymentHost,
            analyticsHost,
            simplPostLinkingRedirectUrl,
            enableWebviewRefreshCapability: true,
        },
        headers: headers as PaymentMainProps["headers"],
        initialState,
    };
}

export function Payment(props: PaymentProps): React.ReactElement {
    const paymentProps = getPaymentProps(props);

    // useMemo is the right hook for this since useEffect is called
    // after component is mounted and we want to change the url
    // before PaymentMain is mounted.
    useMemo(() => {
        if (typeof window !== "undefined" && paymentProps.initialState) {
            const url = window.location.origin + window.location.pathname;
            window.history.replaceState(null, "", url);
        }
    }, [paymentProps.initialState]);

    return (
        <>
            <GlobalDisableCopyPaste />
            <Container>
                <PaymentMain {...paymentProps} externalRoutes={ExternalRoutes} />
            </Container>
        </>
    );
}

export default Payment;
